var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBonus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M4 12.6666C4 12.047 4 11.7373 4.05124 11.4797C4.26165 10.4218 5.08859 9.59491 6.14643 9.38449C6.40403 9.33325 6.71379 9.33325 7.33333 9.33325H16H24.6667C25.2863 9.33325 25.596 9.33325 25.8536 9.38449C26.9115 9.59491 27.7384 10.4218 27.9488 11.4797C28 11.7373 28 12.047 28 12.6666C28 13.2861 28 13.5959 27.9488 13.8535C27.7384 14.9114 26.9115 15.7383 25.8536 15.9487C25.596 15.9999 25.2863 15.9999 24.6667 15.9999H16H7.33333C6.71379 15.9999 6.40403 15.9999 6.14643 15.9487C5.08859 15.7383 4.26165 14.9114 4.05124 13.8535C4 13.5959 4 13.2861 4 12.6666Z",
    stroke: "#B9FF66",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M5.33301 16V21.3333C5.33301 23.8475 5.33301 25.1045 6.11406 25.8856C6.8951 26.6667 8.15218 26.6667 10.6663 26.6667H11.9997H19.9997H21.333C23.8471 26.6667 25.1042 26.6667 25.8853 25.8856C26.6663 25.1045 26.6663 23.8475 26.6663 21.3333V16",
    stroke: "#B9FF66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 9.33325V26.6666",
    stroke: "#B9FF66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M15.1668 8.29217L12.5276 4.99316C11.5347 3.75208 9.68107 3.65197 8.55721 4.77583C6.87731 6.45573 8.06187 9.33333 10.4376 9.33333H14.6664C15.2037 9.33333 15.5025 8.71177 15.1668 8.29217Z",
    stroke: "#B9FF66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16.8331 8.29217L19.4723 4.99316C20.4652 3.75208 22.3188 3.65197 23.4427 4.77583C25.1225 6.45573 23.938 9.33333 21.5623 9.33333H17.3335C16.7961 9.33333 16.4973 8.71177 16.8331 8.29217Z",
    stroke: "#B9FF66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus);
export default __webpack_public_path__ + "static/media/bonus.5fd062a686c899bea5042d5f480f89a8.svg";
export { ForwardRef as ReactComponent };